export const CSRF_COOKIE_NAME = process.env.REACT_APP_CSRF_COOKIE_NAME || 'vylo_csrf';

export const getCookieValue = (name) => {
  if (typeof document === 'undefined') return null;
  const cookies = document.cookie ? document.cookie.split(';') : [];
  for (const cookie of cookies) {
    const trimmed = cookie.trim();
    if (trimmed.startsWith(`${name}=`)) {
      return decodeURIComponent(trimmed.substring(name.length + 1));
    }
  }
  return null;
};

export const withCsrfHeader = (headers = {}) => {
  const csrfToken = getCookieValue(CSRF_COOKIE_NAME);
  if (csrfToken) {
    return { ...headers, 'X-CSRF-Token': csrfToken };
  }
  return headers;
};
